"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getServiceItemIds_1 = require("owa-mail-store/lib/services/utils/getServiceItemIds");
var reportMessageToSafetyLibraryOperation_1 = require("owa-service/lib/operation/reportMessageToSafetyLibraryOperation");
/**
 * Report the message to safety library service
 * @param itemIds the itemIds to update
 * @param safetyApiAction the safetyApiAction type
 * @param actionData the action data
 * @return the ReportMessageToSafetyLibraryResponse
 */
function reportMessageToSafetyLibraryService(itemIdsToUpdate, safetyApiAction, actionData) {
    var requestBody = {
        ItemIds: getServiceItemIds_1.default(itemIdsToUpdate),
        ReportAction: safetyApiAction,
    };
    if (actionData) {
        requestBody.ActionData = actionData;
    }
    return reportMessageToSafetyLibraryOperation_1.default(requestBody).then(function (response) {
        return response.ReportSucccess[0];
    });
}
exports.default = reportMessageToSafetyLibraryService;
//# sourceMappingURL=reportMessageToSafetyLibraryService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/reportMessageToSafetyLibraryService.js
// module id = 3825
// module chunks = 62